import {InfoTextPropsContext} from 'context/infoTextPropsContext';
import React, {ReactNode, useContext} from 'react';

import Markdown from 'components/basic-components/MarkdownContent';
import {withErrorBoundary} from 'components/error/ErrorBoundary';

import InfoPopup from '../InfoPopup';
import styles from './StromInclusivePopup.module.scss';
import {SxProps} from "@mui/material";

interface CDWPopupProps {
  children: ReactNode;
  sx?: SxProps;
}

const StromInclusivePopup = ({children, sx}: CDWPopupProps) => {
  const infoTextProps = useContext(InfoTextPropsContext);
  return (
    <InfoPopup sx={sx} stopPropagation trigger={children}>
      <Markdown
        className={styles.markdown}
        content={infoTextProps.InfoText?.['strom-inklusive']?.markdown}
      />
    </InfoPopup>
  );
};

export default withErrorBoundary(StromInclusivePopup, 'StromInclusivePopup');
